<header class="privacy-policy-header">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <app-navbar></app-navbar>
      </div>
      <div class="col-12 d-flex flex-column align-items-center">
        <h1 class="title">{{"TERMS_CONDITIONS" | translate}}</h1>
        <div class="breadcramb">
          <a class="main" routerLink="/home">{{"HOME" | translate}}</a> / <span class="sub">{{"TERMS_CONDITIONS" |
            translate}}</span>
        </div>
      </div>
    </div>
  </div>
</header>

<section class="privacy-policy-content">
  <div class="container">
    <div class="row">
      <div class="col-12 mb-4">
        <p class="section-title">
          {{"TERMS_CONDITIONS_TITLE1" | translate}}
        </p>
        <p class="regular-text">{{"TERMS_CONDITIONS_CONTENT1" | translate}}</p>
      </div>

      <div class="col-12 mb-4">
        <p class="section-title">
          {{"TERMS_CONDITIONS_TITLE2" | translate}}
        </p>
        <p class="regular-text">{{"TERMS_CONDITIONS_CONTENT2" | translate}}</p>
      </div>

      <div class="col-12 mb-4">
        <p class="section-title">
          {{"TERMS_CONDITIONS_TITLE3" | translate}}
        </p>
        <p class="regular-text">{{"TERMS_CONDITIONS_CONTENT3" | translate}}</p>
      </div>

      <div class="col-12 mb-4">
        <p class="section-title">
          {{"TERMS_CONDITIONS_TITLE4" | translate}}
        </p>
        <p class="regular-text">{{"TERMS_CONDITIONS_CONTENT4" | translate}}</p>
        <p class="regular-text">{{"TERMS_CONDITIONS_CONTENT3_2" | translate}}</p>

      </div>

      <div class="col-12 mb-4">
        <p class="section-title">
          {{"TERMS_CONDITIONS_TITLE5" | translate}}
        </p>
        <p class="regular-text">{{"TERMS_CONDITIONS_CONTENT5" | translate}}</p>
      </div>

      <div class="col-12 mb-4">
        <p class="section-title">
          {{"TERMS_CONDITIONS_TITLE6" | translate}}
        </p>
        <p class="regular-text">{{"TERMS_CONDITIONS_CONTENT6" | translate}}</p>
        <a class="regular-text" (click)="openLink('mailto:info@hidaya.me')">{{' info@hidaya.me'}}</a>
      </div>
    </div>
  </div>
</section>